module.exports = __webpack_public_path__ + "img/heihulogo.cdbbe078.png";